import { Injectable } from '@angular/core';
import { ApiService, UtilService, ApiCacheOptions } from '../../../shared/index';
import { IMailChimpSettingsService } from './imailchimp-settings.service';

@Injectable()
export class MailChimpSettingsService implements IMailChimpSettingsService {
  public _apiService: ApiService;
  public _utilService: UtilService;

  public constructor(apiService: ApiService, utilService: UtilService) {
    this._apiService = apiService;
    this._utilService = utilService;
  }

  /**
   * Checks if MailChimp settings exist. 
   * Wrapped in a catch block to prevent initialization errors if the API fails.
   */
  hasSettings(): Promise<boolean> {
    const route: string = 'mailchimp/hassettings';
    const cacheOptions = new ApiCacheOptions();
    // Correctly disable caching
    cacheOptions.DisableCaching = true;

    return this._apiService.get(route, cacheOptions)
      .then((res: any) => {
        // Ensure we return a boolean even if the API sends something else
        return !!res;
      })
      .catch((error: any) => {
        // If the call fails (404, 500, etc.), we assume no settings and don't break the app
        console.warn('MailChimp settings check failed, defaulting to false.', error);
        return false;
      });
  }
}